import { FormlyFieldConfig } from '@ngx-formly/core';

export function getFieldById(id: string, fields: FormlyFieldConfig[]): FormlyFieldConfig {
	for (let i = 0, len = fields.length; i < len; i++) {
		const field = fields[i];
		if (field.id === id) {
			return field;
		}

		if (field.fieldGroup) {
			const cf = getFieldById(id, field.fieldGroup);
			if (cf) {
				return cf;
			}
		}
	}
}

export function getFieldByKey(key: string, fields: FormlyFieldConfig[]): FormlyFieldConfig {
	for (let i = 0, len = fields.length; i < len; i++) {
		const field = fields[i];
		if (field.key === key) {
			return field;
		}

		if (field.fieldGroup) {
			const cf = getFieldByKey(key, field.fieldGroup);
			if (cf) {
				return cf;
			}
		}
	}
}
